"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
class ErrorBoundary extends _react.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false
    };
  }
  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return {
      hasError: true,
      error
    };
  }
  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    /* eslint-disable no-console */
    console.error(error);
    console.log(errorInfo);
    /* eslint-enable no-console */
    // logErrorToMyService(error, errorInfo);
  }
  render() {
    const {
      hasError
    } = this.state;
    const {
      children,
      fallback
    } = this.props;
    return hasError ? fallback : children;
  }
}
var _default = exports.default = ErrorBoundary;